import { Button, Modal, Image } from 'react-bootstrap';
import useCommonStore from 'store/common';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useRef, useEffect } from 'react';
import { S3_SMALL_THUMB, S3_URL } from 'constants/index';
import { getFileName } from 'utils';
import './slider.scss';

const CarouselModal = () => {
	const { modalConfig = {}, hideCommonModal } = useCommonStore((state) => state);
	const { data: slides = [], id = null } = modalConfig;
	const videoRefs = useRef([]);

	const onModalClose = () => {
		// Pause all videos when modal closes to prevent AbortError
		videoRefs.current.forEach((video) => {
			if (video) {
				video.pause();
			}
		});
		hideCommonModal();
	};

	// Cleanup videos when component unmounts
	useEffect(() => {
		return () => {
			videoRefs.current.forEach((video) => {
				if (video) {
					video.pause();
				}
			});
		};
	}, []);

	const handleSlideChange = (swiper: any) => {
		videoRefs.current.forEach((video, index) => {
			if (video) {
				if (swiper.realIndex !== index) {
					video.pause();
				} else {
					// Handle play() promise to prevent AbortError
					const playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise.catch((error) => {
							// Auto-play was prevented or video was removed from DOM
							// This is expected behavior, so we can safely ignore these errors
							if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') {
								console.warn('Video play failed:', error);
							}
						});
					}
				}
			}
		});
	};

	return (
		<Modal.Body className="p-30">
			<Button className="close-btn rounded-circle fw-bold position-absolute" onClick={onModalClose}>
				<i className="ri-close-line"></i>
			</Button>
			<div className="social-post-image-slider h-100">
				<Swiper
					navigation={{
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}}
					pagination={{ clickable: true }}
					scrollbar={{ draggable: true }}
					onSwiper={handleSlideChange}
					onSlideChange={handleSlideChange}
					centeredSlides={true}
					slidesPerView={1}
					spaceBetween={30}
					loop={true}
					initialSlide={id !== null ? id : 0}
					modules={[Pagination, Navigation]}
					className="mySwiper"
				>
					{slides.length > 0 &&
						slides.map((slide: any, index: number) => (
							<SwiperSlide key={index}>
								{slide.mediaType === 'image' ? (
									<Image loading="lazy" src={`${S3_URL}${slide?.file}`} alt={`slide-${index}`} />
								) : (
									<video
										ref={(el) => (videoRefs.current[index] = el)}
										src={`${S3_URL}${slide?.file}`}
										poster={`${S3_SMALL_THUMB}${getFileName(slide?.file)}`}
										controls
										width="100%"
									/>
								)}
							</SwiperSlide>
						))}

					<div className="swiper-button-prev">
						<i className="ri-arrow-left-s-line"></i>
					</div>
					<div className="swiper-button-next">
						<i className="ri-arrow-right-s-line"></i>
					</div>
				</Swiper>
			</div>
		</Modal.Body>
	);
};

export default CarouselModal;
